import useOnMount from '../useOnMount';
import { fetchAuthInfo } from '../../actions/authActions';

const useAuthentication = (loading, error, authenticated, dispatch) => {
	useOnMount(() => {
		if(!loading && !error && !authenticated) {
			dispatch(fetchAuthInfo());
		}
	});
};

export default useAuthentication;
